<template>
    <header class="page-header">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>Настройки</h2>
                </div>

                <div class="col-12">
                    <ul class="nav settings-tabs">
                        <li class="nav-item">
                            <a :class="'nav-link ' + (submenu === 'main' ? 'active' : '')" @click="updateSubmenu('main')" href="#main">Основные</a>
                        </li>
                        <li class="nav-item">
                            <a :class="'nav-link ' + (submenu === 'api' ? 'active' : '')" @click="updateSubmenu('api')" href="#api">API</a>
                        </li>
                        <li class="nav-item">
                            <a :class="'nav-link ' + (submenu === 'auth' ? 'active' : '')" @click="updateSubmenu('auth')" href="#auth">Авторизация</a>
                        </li>
                        <li class="nav-item">
                            <a :class="'nav-link ' + (submenu === 'email' ? 'active' : '')" @click="updateSubmenu('email')" href="#email">Email</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "SettingsHeader",
        data() {
            return {
                submenu: 'main'
            }
        },

        methods: {
            updateSubmenu(submenu) {
                this.submenu = submenu;
                this.$store.commit('setSubmenu', submenu);
            }
        }
    }
</script>
